import { Field, useFormikContext } from 'formik';
import React from 'react';
import { Fieldset, Select } from '@fourthwall/components';
import { getCountriesOptions } from '@fourthwall/utils/dist/inputs';
import { routing } from '@utils/routing';
import { HSCodeSelect } from './HSCodeSelect';
const countriesOptions = [
    { label: 'Select country', value: '' },
    ...getCountriesOptions({
        withMostPopular: true,
    }),
];
export const TaxFields = React.memo(({ showLearnMoreLinks }) => {
    const { values } = useFormikContext();
    if (
    // manual HS Code entry is available for sell-something-i-have products
    values.fulfillmentService !== 'FULFILLED_BY_CREATOR' &&
        // and ship monk
        values.fulfillmentService !== 'SHIP_MONK' &&
        // and Cart Jazz
        values.fulfillmentService !== 'CART_JAZZ' &&
        // and bespoke
        values.manufacturingService !== 'FOURTHWALL_BESPOKE') {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { component: Select, name: "customsInformation.countryOfOrigin", label: "Country product was manufactured in", options: countriesOptions, defaultValue: "", suggestion: showLearnMoreLinks && (React.createElement(React.Fragment, null,
                        "Required for customs on international shipping.",
                        ' ',
                        React.createElement("a", { href: routing.external.helpCenter.hsCodes, target: "_blank", rel: "noreferrer" }, "Learn more"))) }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { component: HSCodeSelect, name: "customsInformation.shortHsCode", label: "Harmonized System (HS) code", suggestion: showLearnMoreLinks && (React.createElement(React.Fragment, null,
                        "Required for customs on international shipping.",
                        ' ',
                        React.createElement("a", { href: routing.external.helpCenter.hsCodes, target: "_blank", rel: "noreferrer" }, "Learn more"))) })))));
});
